module.exports = __webpack_public_path__ + "static/media/vengean.18733120.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/vengean.webp
// module id = 667
// module chunks = 0